module.exports = __webpack_public_path__ + "img/23.dc4a1e0b.jpg";